import { Component, Output, EventEmitter, ViewChild, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationActions } from '../../actions/application.actions';
import { ApplicationProxyService } from '../../shared/services/applicationproxy.service';
import { FlowManagerService } from '../../shared/services/flowmanager.service';

@Component({
  selector: 'md-upload-later-modal',
  template: require('./upload-later-modal.component.html'),
  styles: [require('./upload-later-modal.component.scss')]
})

export class UploadLaterModalComponent {

  @Output() closeEmitter = new EventEmitter();
  @ViewChild('focusItem') focusItem;

  constructor(router: Router, injector: Injector) {
    this._router = router;
    this.appActions = injector.get(ApplicationActions);
    this.appProxy = injector.get(ApplicationProxyService);
    this.flowManager = injector.get(FlowManagerService);
  }

  ngAfterViewInit() {
    if (this.focusItem) {
      setTimeout(() => {
        this.focusItem.nativeElement.focus();
      }, 0);
    }
  }

  buttonClick(event) {
    if (event) {
      const values = {
        documentRequestId: this.appActions.getData('DocumentUploader.id'),
        type: 'UPLOAD_LATER',
        payload: {}
      };
      this.appProxy.sendEmail(values, resp => {
        if (!resp) {
          this.flowManager.resetPageError();
          this.closeEmitter.emit(event);
        } else {
          this.closeEmitter.emit();
        }
      });
    } else {
      this.closeEmitter.emit();
    }
  }

}
